/**
 * EG-55 — reflete na tela a classificação que o LOTE acabou de gravar.
 *
 * POR QUE ISSO NÃO PODE SER handleEditQuestion EM LOOP
 *   A primeira versão chamava o caminho individual uma vez por questão. O
 *   caminho individual termina com append()/remove() — para forçar o
 *   useFieldArray a reler os cards — e com um reset() que rebaseia o estado
 *   limpo. Em loop, o reset da primeira iteração descarta os setValue das
 *   seguintes: só a PRIMEIRA questão aparecia na tela, e o resto só depois de
 *   recarregar a página.
 *
 *   O lote precisa da mesma mecânica UMA vez: grava todos os valores, depois
 *   força o re-render, depois rebaseia.
 *
 * POR QUE NÃO SUJAR O FORMULÁRIO
 *   A classificação já está persistida (o lote gravou por endpoint próprio). Se
 *   ela sujasse o form, o botão Finalizar acenderia e induziria o gestor a gerar
 *   uma versão nova sem motivo — e versionar soft-deleta a linhagem e recria
 *   TODAS as questões com ids novos, exatamente o que faz a propagação perder o
 *   alvo. A guarda do estavaSujo preserva uma edição estrutural ainda pendente.
 */
export function refletirClassificacaoEmMassa(
  { ids, id_pillar, id_theme, gri_ids },
  { getValues, setValue, append, remove, reset, isDirty }
) {
  const questoes = getValues().form || [];
  const alvos = new Set((ids ?? []).map(Number));

  const indicesAtingidos = questoes.reduce((acc, questao, idx) => {
    if (alvos.has(Number(questao.id_question_template))) acc.push(idx);
    return acc;
  }, []);

  if (indicesAtingidos.length === 0) return 0;

  indicesAtingidos.forEach((idx) => {
    const atual = questoes[idx];
    // COALESCE do lado do cliente, espelhando o do backend: quem não veio no
    // payload mantém o que já tinha.
    setValue(`form[${idx}][id_pillar]`, id_pillar ?? atual.id_pillar ?? null);
    setValue(`form[${idx}][id_theme]`, id_theme ?? atual.id_theme ?? null);

    // GRI-02: no lote a semântica é ACRESCENTAR (mesma regra do backend em
    // classificacao.js), não substituir — por isso soma ao que a questão já
    // tinha, em vez de sobrescrever. Sem isto o card só mostrava os
    // indicadores novos depois de um F5, porque RotuloGri lê gri_ids do
    // FORMULÁRIO (não recebe os objetos completos), e ninguém atualizava esse
    // campo aqui — só id_pillar/id_theme.
    if (Array.isArray(gri_ids) && gri_ids.length > 0) {
      const atuais = (atual.gri_ids ?? []).map(Number);
      const novos = [...new Set([...atuais, ...gri_ids.map(Number)])];
      setValue(`form[${idx}][gri_ids]`, novos);
    }
  });

  // Uma vez só, depois de todos os setValue: o par append/remove existe para o
  // useFieldArray reler os valores e re-renderizar os cards com o rótulo novo.
  append();
  remove(getValues().form.length - 1);

  if (!isDirty) {
    reset(getValues(), { keepValues: true, keepErrors: true, keepTouched: true });
  }

  return indicesAtingidos.length;
}
